module.exports = __webpack_public_path__ + "img/points_verification.b019a0b6.svg";